import React from 'react';
const LoggerContext = React.createContext({
    info: console.info,
    debug: console.debug,
    error: console.error,
    warn: console.warn
});
export default LoggerContext;
